import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { IDriver, IDriverDTO } from '../interfaces/driver';
import { IDriverFilter } from '../interfaces/driver-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { FilterValue } from 'crossfilter2';
import { IFilterValue } from '../interfaces/filter-value';

@Injectable({ providedIn: 'root' })
export class IDriverService extends EditService<IDriver, IDriverFilter> {
  url = '/api/driver';
  entityTitle = 'Driver';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  saveDriver(data: any): Promise<any> {
    let successMsg =
      typeof data.id != undefined && data.id != 0 ? 'Driver updated.' : 'Driver added.';

    return this.handleRequest(
      this.http.post(`${this.url}` + '/save', data),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  resetCode(driverId: number): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}` + '/resetcode', { driverId: driverId }),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }

  getAll(supplierId: any): Promise<IDriver[]> {
    //getAll(supplierId: any): Promise<IDriver[]> {
    return this.handleRequest(
      this.http.get<IDriver[]>(`${this.url}` + '/getAll/' + supplierId),
      this.handlersFactory.getForReadAll(),
    );
  }

  getList(filter: IDriverFilter): Promise<IDriverDTO[]> {
    return this.handleRequest(
      this.http.get<IDriverDTO[]>(`${this.url}` + '/getList', {
        params: this.constructHttpParams(filter),
      }),
      this.handlersFactory.getForReadAll(),
    );
  }

  getContractDrivers(contractTypeId: any): Promise<IDriver[]> {
    //getAll(supplierId: any): Promise<IDriver[]> {
    return this.handleRequest(
      this.http.get<IDriver[]>(`${this.url}` + '/contractDrivers/' + contractTypeId),
      this.handlersFactory.getForReadAll(),
    );
  }

  sendMessage(driverId: number, message: string, taskId: number): Promise<void> {
    return this.http
      .post<void>(`${this.url}` + '/sendMessage', {
        driverId: driverId,
        message: message,
        taskId: taskId,
      })
      .toPromise();
  }

  getAccessDetails(driverId: number): Promise<any> {
    return this.handleRequest<any>(
      this.http.get<any>(this.url + '/accessDetails/' + driverId),
      this.handlersFactory.getForReadById(this.entityTitle),
    );
  }

  lockUplockDriver(driver) {
    return this.handleRequest(
      this.http.post(`${this.url}` + '/lockunlock', driver),
      this.handlersFactory.getForUpdate(this.entityTitle),
    );
  }
}
